export default {
  emits: ["save", "edit", "error"],
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: {},
      defaultData: {},
      url: "",
      updateUrl: "",
      hasFileInput: false,
      datesCols: [],
      apiResponse:{},
      errors: {},
      errorMessage:"",
    };
  },
  computed: {
    isEdit() {
      return !!this.item?.id;
    },
  },
  watch: {
    item: {
      handler() {
        this.resetForm();
      },
      deep: true,
      immediate: true,
      loader: {},
    },
  },
  methods: {
    resetForm() {
      if (!this.item || Object.keys(this.item).length === 0) {
        this.formData = Object.assign({}, this.defaultData);
        return;
      }
      this.formData = Object.assign({}, this.item);

      this.datesCols.forEach((col) => {
        if (this.formData[col]) {
          this.formData[col] = this.shrinkDateForInput(this.formData[col]);
        }
      });
    },
    shrinkDateForInput(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    parseData() {},
    beforeSave() {},
    afterSave() {},
    takeFileInput(event, fieldName) {
      const file = event.target.files[0];
      this.formData[fieldName] = file;
      this.hasFileInput = true;
    },
    save() {
      this.spinner();
      this.parseData();
      this.beforeSave();

      let saveUrl = this.url;
      if (this.isEdit) {
        this.formData._method = "PUT";
        saveUrl = this.updateUrl || `${this.url}/${this.item.id}`;
      }

      let options = {};
      if (this.hasFileInput) {
        options.headers = { "Content-Type": "multipart/form-data" };
      }

      //   console.log("Saving data to:", saveUrl, "Data:", this.formData);return;

      this.$api
        .post(saveUrl, this.formData, options)
        .then((response) => {

          this.resetForm();
          this.apiResponse = response.data;
          if (this.isEdit) {
            this.$emit("edit", this.apiResponse.data);
            return;
          } else {
            this.$emit("save", this.apiResponse.data);
          }
          this.errors = Object.assign({}, {});
          this.errorMessage = "";
          this.afterSave();
        })
        .catch((error) => {
          console.log('saveError',this.errors);

          this.$emit("error", error);
          this.errors = error.response.data?.errors ?? error.response.data?.data;
          this.errorMessage = error.response.data?.message;
        })
        .finally(() => {
          this.hasFileInput = false;
          this.hideSpinner();
        });
    },

    spinner() {
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel,
      });
    },
    hideSpinner() {
      this.loader.hide();
    },
    imageLink(attr, serverSideUrlAttr = "image_path") {
      return this.formData[attr]
        ? URL.createObjectURL(this.formData[attr])
        : this.formData[serverSideUrlAttr]
        ? this.$api.defaults.assetsBaseURL + this.formData[serverSideUrlAttr]
        : require("@/assets/default.png");
    },
  },
  created() {
    this.resetForm();
  },
};
